<ng-template #content>
  <div class="modal-header">
    <h4 class="modal-title">Keyboard shortcuts</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
  <div class="modal-body">
    <dl>
      @for (shortcut of shortcuts; track shortcut.keys[0]) {
        <dt>
          @for (key of shortcut.keys; track key; let last = $last) {
            <kbd>{{ key }}</kbd>
            @if (!last) {
              <span>&nbsp;/&nbsp;</span>
            }
          }
        </dt>
        <dd>{{ shortcut.description }}</dd>
      }
    </dl>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  </div>
</ng-template>
